import React, { createRef, Fragment } from 'react';
import { Form, Icon, Input, Button, message } from 'antd';
import styles from './index.scss';
import Api from '../../utils/api';
import eventProxy from 'react-eventproxy';
import { Redirect } from 'react-router-dom'

const eventLoginName = 'onLoginSuccess'
/**
 * 登陆页面
 */
class NormalLoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            userName: '', //用户名
            passWord: '', //密码
        }
    }

    onKeyUp = (e) => {
        if (e.keyCode === 13) {
            this.handleSubmit();
        }
    }
    handleSubmit() {
        const self = this;
        const { userName, passWord } = self.state
        // e.preventDefault();
        if (!userName) {
            message.error('请输入用户名');
            return
        }
        if (!passWord) {
            message.error('请输入密码');
            return
        }
        // console.log(userName, passWord)
        const hide = message.loading('登陆中...', 0);
        Api.login({ userName: userName, userPasswd: passWord }).then(res => {
            function guid() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            }
            hide();
            sessionStorage.setItem("adminStaffArea", JSON.stringify(res.staffArea));
            sessionStorage.setItem("adminStoreInfo", JSON.stringify(res.storeInfo));
            sessionStorage.setItem("adminStaffInfo", JSON.stringify(res.staffInfo));
            eventProxy.trigger(eventLoginName, guid())

        }).catch(e => {
            hide();
            message.error(e || "登陆出现错误")
        });
    };

    render() {
        const { userName, passWord } = this.state
        let self = this
        return (
            <div id='liginView'>
                <div style={{ marginLeft: 290, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    <img src={require('../../images/logo.png')} style={{ width: 279, height: 71 }} />
                    <p style={{ fontSize: 28, color: '#D4D4D4' }}>SOREAL 场控管理系统 v1.0.0</p>
                    <div style={{ display: 'flex', flexDirection: 'column', marginTop: 64 }}>
                        <Input
                            placeholder="请输入员工账号或手机号"
                            prefix={<img src={require('../../images/user_icon.png')} style={{ width: 24, height: 24 }} />}
                            style={{ width: 330, height: 44, borderRadius: 22, overflow: 'hidden' }}
                            onChange={e => {
                                self.setState({
                                    userName: e.currentTarget.value
                                })
                            }}
                            className='inputStyle'
                            allowClear
                        />
                        <Input.Password
                            placeholder="请输入密码"
                            prefix={<img src={require('../../images/pass_icon.png')} style={{ width: 24, height: 24 }} />}
                            style={{ width: 330, height: 44, borderRadius: 22, overflow: 'hidden', marginTop: 40 }}
                            onChange={e => {
                                self.setState({
                                    passWord: e.currentTarget.value
                                })
                            }}
                            // allowClear
                            className='inputStyle'
                            onKeyUp={this.onKeyUp}
                        />

                    </div>
                    <Button  onClick={this.handleSubmit} style={{ width: 220, height: 44, backgroundColor: userName && passWord ? '#21E6A6' : '#24213F', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 16, color: '#5B5B77', borderRadius: 22, marginTop: 50, border: 'none' }}>登 录</Button>
                </div>
                <p style={{ marginLeft: 247, marginTop: 162, color: '#6D738C', fontSize: 14 }}>Copyright©2020 SROEAL场控管理系统平台Inc. All right reserved.</p>
            </div>
        );
    }
}

const WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(NormalLoginForm);

export default class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoginSuccess: sessionStorage.getItem('token') ? true : false
        }
    }

    componentDidMount() {
        const self = this;
        eventProxy.on(eventLoginName, (key) => {
            sessionStorage.setItem("token", key);
            self.setState({
                isLoginSuccess: true
            })
        })
    }
    
    // componentRef = createRef();
    render() {
        return (
            <div className={styles.container}>
                <div className={styles.divlogin}>
                    {
                        !this.state.isLoginSuccess ? <WrappedNormalLoginForm /> : null
                    }
                    {
                        this.state.isLoginSuccess ? <Redirect
                            to={{
                                pathname: "/home",
                            }}
                        /> : null
                    }

                </div>
            </div>
        );
    }
}